import {APP} from 'src/style/variable';
export const spaceBottomStyle = {
  marginBottom: '1.3rem'
};
export const textArea = {
  height: 40,
  width: '100%',
  borderColor: '#c1c1c1',
  borderRadius: '3pt',
  paddingTop: '1rem',
  paddingLeft: '0.8rem',
  opacity: 0.6,
  fontFamily: APP.FONT_FAMILY.REGULAR,
  fontSize: '1rem'
};
